import { render } from "./LinceObligationCard.vue?vue&type=template&id=4e4db777&scoped=true&ts=true"
import script from "./LinceObligationCard.vue?vue&type=script&lang=ts"
export * from "./LinceObligationCard.vue?vue&type=script&lang=ts"

import "./LinceObligationCard.vue?vue&type=style&index=0&id=4e4db777&lang=css&scoped=true"

import exportComponent from "/codebuild/output/src1651641719/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e4db777"]])

export default __exports__